import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
    // Dismiss the React dev-mode error overlay so our screen shows cleanly
    setTimeout(() => {
      const overlay = document.getElementById('react-error-overlay') ||
                      document.querySelector('iframe[id^="react-error-"]') ||
                      document.querySelector('body > div[style*="z-index: 2147483647"]');
      if (overlay) overlay.remove();
    }, 0);
  }

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-base, #f8fafc)',
        padding: 24,
        fontFamily: 'Inter, system-ui, sans-serif',
        zIndex: 99999,
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: 440,
          width: '100%',
        }}>
          {/* Icon */}
          <div style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            background: 'rgba(239,68,68,0.12)',
            border: '1.5px solid rgba(239,68,68,0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          {/* Heading */}
          <h2 style={{
            margin: '0 0 10px',
            fontSize: 22,
            fontWeight: 700,
            color: 'var(--text-primary, #f1f5f9)',
          }}>
            Something went wrong
          </h2>

          {/* Sub-text */}
          <p style={{
            margin: '0 0 32px',
            fontSize: 14,
            lineHeight: 1.6,
            color: 'var(--text-secondary, #94a3b8)',
          }}>
            An unexpected error occurred on this page. You can try again or go back to the home page.
          </p>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={this.handleRetry}
              style={{
                padding: '10px 22px',
                borderRadius: 10,
                border: '1.5px solid var(--border-subtle, rgba(255,255,255,0.1))',
                background: 'transparent',
                color: 'var(--text-primary, #f1f5f9)',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'opacity 0.15s',
              }}
              onMouseOver={e => e.currentTarget.style.opacity = '0.7'}
              onMouseOut={e => e.currentTarget.style.opacity = '1'}
            >
              Try again
            </button>
            <button
              onClick={this.handleGoHome}
              style={{
                padding: '10px 22px',
                borderRadius: 10,
                border: 'none',
                background: '#6366f1',
                color: '#fff',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'opacity 0.15s',
              }}
              onMouseOver={e => e.currentTarget.style.opacity = '0.85'}
              onMouseOut={e => e.currentTarget.style.opacity = '1'}
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
